const TealWave = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 1440 55"
    className="w-full"
    aria-hidden="true"
    width="1440"
    height="55"
    fill="none"
  >
    <path
      d="M-3730 4450C-3730 1302.18 -2813 0 720 0C4253 0 5170 1302.18 5170 4450C5170 7597.82 4253 8900 720 8900C-2813 8900 -3730 7597.82 -3730 4450Z"
      fill="#71E6C0"
    />
  </svg>
);

export default TealWave;
